<h2 mat-dialog-title>Portal order #{{ order.deliveryNumber }}</h2>

<mat-dialog-content>

  <div class="loading" *ngIf="loading">Checking the order against this week's menu…</div>

  <ng-container *ngIf="!loading">

    <div class="warn" *ngIf="menuMissing">
      <mat-icon>warning</mat-icon>
      <span>There is no menu for that week any more. Check with the kitchen before approving.</span>
    </div>

    <div class="warn" *ngIf="changed.length">
      <mat-icon>warning</mat-icon>
      <div>
        <div>The menu changed after this order was placed:</div>
        <ul>
          <li *ngFor="let c of changed">
            {{ c.productType }} — ordered <strong>{{ c.ordered }}</strong>, menu now has
            <strong>{{ c.now }}</strong>
          </li>
        </ul>
        <div class="warn-note">Approving sends the products as ordered. Reject instead if the customer should re-order.</div>
      </div>
    </div>

    <div class="facts">
      <div class="fact"><span class="label">Customer</span><span class="value">{{ order.name }} ({{ order.email }})</span></div>
      <div class="fact"><span class="label">Date</span><span class="value">{{ deliveryDate() }}</span></div>
      <div class="fact"><span class="label">System</span><span class="value">{{ order.systemName || '—' }}</span></div>
      <div class="fact"><span class="label">For</span><span class="value">{{ order.desciption }}</span></div>
      <div class="fact" *ngIf="order.comment"><span class="label">Comment</span><span class="value">{{ order.comment }}</span></div>
    </div>

    <table class="lines">
      <thead>
        <tr>
          <th>Product</th>
          <th class="num">Qty</th>
          <th class="num">Unit</th>
          <th class="num">Sum</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let line of productLines()">
          <td>
            <div>{{ line.product }}</div>
            <div class="type">{{ line.productType }}</div>
          </td>
          <td class="num">{{ line.amount }}</td>
          <td class="num">{{ kr(line.unitPrice) }}</td>
          <td class="num">{{ kr(line.lineTotal) }}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="3" class="num total-label">Total incl. VAT</td>
          <td class="num total">{{ kr(order.totalIncVat) }}</td>
        </tr>
        <tr *ngIf="order.totalExVat">
          <td colspan="3" class="num total-label">Ex VAT</td>
          <td class="num">{{ kr(order.totalExVat) }}</td>
        </tr>
      </tfoot>
    </table>

    <div class="approve-note" *ngIf="!rejecting">
      Approving sends the logistics mail (08:00 the day before), the IL mail for
      anything made fresh, and a confirmation to the customer.
    </div>

    <mat-form-field appearance="outline" class="reason" *ngIf="rejecting">
      <mat-label>Why not?</mat-label>
      <input matInput [(ngModel)]="rejectReason" placeholder="The customer is shown this" maxlength="200">
    </mat-form-field>

  </ng-container>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()" [disabled]="working">Close</button>

  <ng-container *ngIf="!rejecting">
    <button mat-stroked-button color="warn" (click)="rejecting = true" [disabled]="loading || working">Reject…</button>
    <button mat-flat-button color="primary" (click)="approve()" [disabled]="loading || working">
      {{ working ? 'Working…' : 'Approve' }}
    </button>
  </ng-container>

  <ng-container *ngIf="rejecting">
    <button mat-button (click)="rejecting = false; rejectReason = ''" [disabled]="working">Back</button>
    <button mat-flat-button color="warn" (click)="reject()" [disabled]="working">
      {{ working ? 'Working…' : 'Reject order' }}
    </button>
  </ng-container>
</mat-dialog-actions>
